<template>
  <footer
    :class="cn('max-w-300', footerClass)"
    class="mx-auto px-6 py-8 text-xs/4.5 text-neutral-emphasis md:py-12">
    <div class="mx-auto">
      <div v-if="hasDisclaimer">
        <p class="mb-3">
          {{ t("footer.copy_1") }}
        </p>
        <p class="mb-4">
          {{ t("footer.copy_2") }}
        </p>
      </div>
      <div class="flex flex-wrap">
        <RouterLink
          :to="{
            name: 'impressum',
          }"
          class="mr-4 underline"
          @click="
            trackEvent('footer_click_textButton_footerlink', '/impressum')
          ">
          {{ t("footer.nav.imprint") }}
        </RouterLink>
        <RouterLink
          :to="{
            name: 'privacy',
          }"
          class="mr-4 underline"
          @click="trackEvent('footer_click_textButton_footerlink', '/privacy')">
          {{ t("footer.nav.privacy") }}
        </RouterLink>
        <RouterLink
          :to="{
            name: 'termsOfUse',
          }"
          class="mr-4 underline"
          @click="
            trackEvent('footer_click_textButton_footerlink', '/terms-of-use')
          ">
          {{ t("footer.nav.tos") }}
        </RouterLink>
        <a
          data-testid="cookies"
          class="mr-4 cursor-pointer underline"
          @click="openCookieSettings">
          {{ t("footer.nav.cookies") }}
        </a>
      </div>
    </div>
  </footer>
</template>

<script lang="ts" setup>
import { cn } from "@dpa-id-components/dpa-shared-components/src/utils/cn.ts";
import { useI18n } from "vue-i18n";

import { useTracking } from "@/composition/shared/useTracking.ts";

const { t } = useI18n();
const { trackEvent } = useTracking();

const { footerClass = undefined, hasDisclaimer = false } = defineProps<{
  footerClass?: string;
  hasDisclaimer?: boolean;
}>();

function openCookieSettings() {
  window.OneTrust?.ToggleInfoDisplay?.();
}
</script>
